import { useSyncExternalStore } from "react";

const MD = "(min-width: 768px)";

// One shared MediaQueryList for every consumer. jsdom has no matchMedia — fall back to
// innerWidth so tests can drive the breakpoint.
let mql: MediaQueryList | null = null;
const getMql = () => {
  if (!mql && typeof window.matchMedia === "function") mql = window.matchMedia(MD);
  return mql;
};

const getSnapshot = () => getMql()?.matches ?? window.innerWidth >= 768;

const subscribe = (onChange: () => void) => {
  const list = getMql();
  if (!list) return () => undefined;
  list.addEventListener("change", onChange);
  return () => list.removeEventListener("change", onChange);
};

/** Tracks the Tailwind `md` breakpoint — the split between the mobile and desktop booking flows. */
export const useIsMdUp = (): boolean => useSyncExternalStore(subscribe, getSnapshot);
